var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"category"},[_c('sidebar',{staticClass:"left",attrs:{"list":_vm.sidebar,"activeIndex":_vm.sidebarIndex},on:{"seleced":_vm.seleced}}),_c('cate',{staticClass:"right",attrs:{"list":_vm.rightSidebarList}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }